import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'profile-box',
    templateUrl: './profile-box.component.html',
    styleUrls: ['./profile-box.component.scss'],
    standalone: false
})
export class ProfileBoxComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
